import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { CloseIcon } from '../../Icon';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
const StyledCloseIconWrapper = styled.span`
  width: 30px;
  height: 30px;
  top: -15px;
  left: -15px;
  padding: 4px;
  position: absolute;
  z-index: 99;
  background: #327388;
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;
`;

const StyledCaption = styled.div`
  text-align: right;
  font: normal normal 600 15px/20px Lato;
  letter-spacing: 0.5px;
  color: #242325;
  margin: 0 auto 2rem;
  min-height: 20px;
  display: flex;
  flex-direction: column;
  cursor: default;
`;

const StyledLink = styled.span`
  font: normal normal 400 12px/20px Lato;
  letter-spacing: 0.5px;
  color: #327388;
  text-align: right;
  cursor: pointer;
`;

type Props = {
  modalIsOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};

export const AccountLoginModal = ({
  modalIsOpen,
  openModal,
  closeModal,
}: Props) => {
  const [state, send] = useService(productBuilderMachine);
  const {
    productWithMeasurements,
    // cart,
    // measureInsurance: measureInsuranceProducts,
    // custom: { measureInsurance },
    customer,
  } = state.context;

  const openLoginPage = () => {
    localStorage.setItem(
      'productWithMeasurements',
      JSON.stringify(productWithMeasurements),
    );
    localStorage.setItem('productUrl', window.location.href);
    window.location.href = '/account/login';
  };

  const customStyles = {
    overlay: {
      zIndex: 999,
      backgroundColor: 'rgb(36,35,37, 0.25)',
    },
    content: {
      top: '200px',
      left: 'calc(100% - 190px)',
      width: '200px',
      height: '75px',
      bottom: 'auto',
      border: '3px solid #327388',
      borderRadius: '10px',
      padding: '0.5rem 2rem 0.5rem 0.5rem',
      overflow: 'visible',
    },
  };

  Modal.setAppElement('#root');

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
    >
      <StyledWrapper>
        <StyledCloseIconWrapper onClick={closeModal}>
          <CloseIcon />
        </StyledCloseIconWrapper>
        <StyledCaption>
          Already have Measure Insurance?
          <StyledLink onClick={openLoginPage}>Log into your account</StyledLink>
        </StyledCaption>
      </StyledWrapper>
    </Modal>
  );
};
